














import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class InputFileSimple extends Vue {
    @Prop({ type: Boolean, default: false }) readonly notNullable!: boolean
    @Prop({ type: Boolean, default: false }) readonly trim!: boolean
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    internalValue: string = null
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    transformInput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    transformOutput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (this.notNullable === false && typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(event: Event): void {
        const element = event.target as HTMLInputElement
        const fileList = element.files

        if (fileList && fileList.length > 0) {
            this.$emit('input', fileList.item(0))
        }
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    get componentClass(): object {
        return {
            'input-file-simple': true,
            'bd-round-outline': true,
            'input-file-simple--focussed': this.focus,
            'input-file-simple--disabled': this.disabled,
        }
    }
}
